import { z } from 'zod';
import { extendZodWithOpenApi } from '@asteasolutions/zod-to-openapi';
extendZodWithOpenApi(z);
export const LearningEpisodeSchema = z
    .object({
    id: z.string().uuid(),
    userId: z.string().uuid(),
    startedAt: z.string().openapi({ description: 'ISO 8601 timestamp' }),
    endedAt: z.string().nullable().openapi({ description: 'ISO 8601 timestamp, null if active' }),
    sessionCount: z.number().int(),
    createdAt: z.string(),
    updatedAt: z.string(),
})
    .openapi('LearningEpisode');
//# sourceMappingURL=learning-episode.schema.js.map